<template>
    <div class="nav-box">
        <div class="nav-dropDown" v-if="vm.children&&vm.children.length>0" v-clickoutside="hideSub">
            <div class="main-nav" @click.stop.prevent="togglenNav">
                <span>{{vm.name}}</span>
                <div class="trigangle" :class="{ openStatus: vm.type === type }"></div>
            </div>
            <div class="nav-sub-box" v-show="vm.type === type">
                <div class="nav-sub-item" @click.prevent.stop="goPath(item.path)" v-for="(item, index) in vm.children" :key="index" :class="{active: $route.path === item.path}">{{item.name}}</div>
            </div>

        </div>
        <div v-else class="nav-temp" @click="goPath(vm.path)">{{vm.name}}</div>
    </div>
</template>
<script>
import '../../directive/click-outside'
export default {
  props: {
    vm: {
      type: Object
    },
    type: {
      type: Number
    }
  },
  data () {
    return {
      isShow: false
    }
  },
  computed: {
    isCurrent () {
      return this.vm.children.filter(item => { return item.path === this.$route.path }).length > 0
    }
  },
  //   watch: {
  //     '$route.path': function (val) {
  //       console.log(val)
  //       if (this.vm.children && this.vm.children.length > 0) {
  //         console.log(this.vm.children.filter(item => { return item.path === val }))
  //         this.isShow = this.vm.children.filter(item => { return item.path === val }).length > 0
  //       }
  //     }
  //   },
  methods: {
    showSub () {
      this.isShow = true
    },
    togglenNav () {
      this.$emit('select', { isClose: false, type: this.vm.type })
    },
    hideSub () {
      this.isShow = false
    },
    goPath (path) {
      this.isShow = false
      this.$emit('select', { isClose: true, type: this.vm.type })
      this.$router.push(path)
    }
  }
}
</script>
<style lang="scss" scoped>
.nav-box{
  position: relative;
  text-align: left;
  .nav-dropDown{
    font-size: rem(42);
    font-weight: 800;
    line-height: rem(90);
    position: relative;
    .nav-sub-box{
        line-height: rem(100);
        margin-left: rem(50);
        font-size: rem(32);
        font-weight:500;
        .active {
            color: #FF6D00 !important;
        }
    }
    .trigangle{
      position: absolute;
      top: rem(30);
      right: rem(400);
      width: rem(17);
      height: rem(31);
      background: url("https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/icon-arrow-m.png") no-repeat center;
      background-size: 100% 100%;
      transform: rotateZ(0deg);
      transition: transform .5s;
    }
    .openStatus{
        transform: rotateZ(90deg);
        transition: transform .5s;
    }
  }
  .nav-temp{
    font-size: rem(42);
    font-weight: 800;
    line-height: rem(100);
  }
}
</style>
